import { Box } from '@mui/material';
import { TOptions } from 'i18next';
import { mergeSx } from 'merge-sx';

import { AbgTypography, AlertIcon, useTranslation } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

import { BookingWidgetI18nItem } from '../../../organisms/BookingWidget/booking-widget.types';
import { useBookingWidgetContext } from '../../../organisms/BookingWidget/hooks';
import { DateTimePickerErrorEnum } from '../types';

import {
  errorBannerStyling,
  errorIconStyling,
} from './DateTimePickerErrorBanner.styling';

const getErrorData = (
  t: (item: BookingWidgetI18nItem, options?: TOptions) => string,
  showDateTimePickerError: DateTimePickerErrorEnum,
  maxBookingPeriod: number,
) => {
  switch (showDateTimePickerError) {
    case DateTimePickerErrorEnum.maxBookingPeriod: {
      return {
        title: t('bookingWidget.date.maxdays.validation.text', {
          count: maxBookingPeriod,
        }),
        testid: 'maxBookingPeriodError',
      };
    }
    case DateTimePickerErrorEnum.dropoffTimeNotLaterThanPickup: {
      return {
        title: t('bookingWidget.date.error.dropoffTimeNotLaterThanPickup'),
        testid: 'dropoffTimeError',
      };
    }
  }
};

export const DateTimePickerErrorBanner = ({
  showDateTimePickerError,
  maxBookingPeriod,
  sxOverrides,
}: {
  showDateTimePickerError: DateTimePickerErrorEnum;
  maxBookingPeriod: number;
  sxOverrides?: AbgSxProps;
}) => {
  const { model } = useBookingWidgetContext();
  const t = useTranslation(model.i18n);

  const errorData = getErrorData(t, showDateTimePickerError, maxBookingPeriod);

  return (
    <Box sx={mergeSx(errorBannerStyling, sxOverrides)}>
      <AlertIcon sx={errorIconStyling} />

      <AbgTypography
        variant="metadataRegular"
        color="#B31534"
        data-testid={errorData.testid}
      >
        {errorData.title}
      </AbgTypography>
    </Box>
  );
};
